import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  filters: [],
  currentFilters: [],
  results: [],
  isLoading: false,
  lastQueryStr: null,
  sort: null,
  searchTerm: null,
  filtersVisible: window.matchMedia('(min-width: 768px)').matches,
  pagination: {
    page: 1,
    limit: 12,
    total: 0,
    viewAll: false
  }
}

const getters = {
  getCurrentFiltersQueryStr: (state) => {
    const category = state.currentFilters
      .filter(currentFilter => currentFilter.type === 'category')
      .map(currentFilter => currentFilter.id).join(',')

    const type = state.currentFilters
      .filter(currentFilter => currentFilter.type === 'type')
      .map(currentFilter => currentFilter.id).join(',')

    const subject = state.currentFilters
      .filter(currentFilter => currentFilter.type === 'subject')
      .map(currentFilter => currentFilter.id).join(',')

    const search = state.searchTerm === null ? '' : state.searchTerm

    return `?category=${category}&type=${type}&subject=${subject}&search=${search}`
  }
}

const mutations = {
  setCurrentFilterOption (state, filter) {
    const currentFilterIndex = state.currentFilters.findIndex(currentFilter => currentFilter.id === filter.id)

    if (currentFilterIndex > -1) {
      state.currentFilters.splice(currentFilterIndex, 1)
    } else {
      state.currentFilters.push(filter)
    }

    // Remove any dependant filters if the filter they depend on is no longer selected
    state.currentFilters
      .filter((currentFilter) => {
        return Object.prototype.hasOwnProperty.call(currentFilter, 'depends_on') &&
          !currentFilter.depends_on.some(id => state.currentFilters.map(filter => filter.id).includes(id))
      })
      .forEach((dependantFilter) => {
        const dependantFilterIndex = state.currentFilters.findIndex(currentFilter => currentFilter.id === dependantFilter.id)
        state.currentFilters.splice(dependantFilterIndex, 1)
      })

    this.dispatch('fetchResults')
  },

  loadInitialData(state, initialData) {
    state.filters = initialData.filters
    state.results = initialData.results
    state.searchTerm = initialData.search
    state.pagination.total = initialData.results.length

    const allFilters = initialData.filters.reduce((acc, val) => acc.concat(val.filters), [])
    let initialFilters = []

    if (initialData.category) {
      const initialCategories = initialData.category.split(',').map(id => parseInt(id))
      const foundFilters = allFilters.filter(f => initialCategories.includes(f.id))

      if (foundFilters) {
        initialFilters = initialFilters.concat(foundFilters)
      }
    }

    if (initialData.type) {
      const initialTypes = initialData.type.split(',').map(id => parseInt(id))
      const foundFilters = allFilters.filter(f => initialTypes.includes(f.id))

      if (foundFilters) {
        initialFilters = initialFilters.concat(foundFilters)
      }
    }

    state.currentFilters = initialFilters
  },

  updateLastQueryStr(state) {
    state.lastQueryStr = this.getters.getCurrentFiltersQueryStr
  },

  updateResults(state, newResults) {
    state.results = newResults
  },

  setSort(state, newSort) {
    state.sort = newSort
    state.pagination.page = 1
  },

  setTotal(state, total) {
    state.pagination.total = total
  },

  prevPage(state) {
    state.pagination.page -= 1
  },

  nextPage(state) {
    state.pagination.page += 1
  },

  setPage(state, newPage) {
    state.pagination.page = parseInt(newPage)
  },

  toggleViewAll(state) {
    state.pagination.viewAll = !state.pagination.viewAll
  },

  toggleFilters(state) {
    state.filtersVisible = !state.filtersVisible
  },

  clearFilters(state) {
    state.currentFilters = []
    state.searchTerm = null

    this.dispatch('fetchResults')
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },

  setSearch(state, searchTerm) {
    if (searchTerm === '') {
      state.searchTerm = null
    } else {
      state.searchTerm = searchTerm.toLowerCase()
    }

    this.dispatch('fetchResults')
  }
}

const actions = {
  fetchResults ({ state, commit, getters }) {
    if (state.lastQueryStr !== getters.getCurrentFiltersQueryStr) {
      commit('updateLastQueryStr')
      commit('setLoading', true)

      const endpoint = window._storeApiEndpoint.split('?')[0]

      ajax.get(endpoint + getters.getCurrentFiltersQueryStr)
        .then((resp) => {
          commit('updateResults', resp.data)
          commit('setTotal', resp.data.length)
          commit('setPage', 1)
          commit('setLoading', false)
        })
    }
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
